import { useState } from 'react';
import styled from '@emotion/styled';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

import { Popover, Button, ButtonGroup, Tooltip } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import useQueryParams from '../../../hooks/useQueryParams';

import { getToday, getDateParts } from '../helpers';

import useIsMobile from '../../../hooks/useIsMobile';

// icons
import GpsFixedRoundedIcon from '@mui/icons-material/GpsFixedRounded';
import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import { BasicFlex } from '../../../utils/Common';

import { getLuxonDate } from '../../../utils/util';

const ActionButton = styled(Button)`
  min-width: auto !important;
  padding: .8rem;
  font-weight: 500;

  @media ${props => props.theme.breaks.down('md')} {
    padding: .4rem;
  }
`;

const CalendarSelect = ({navigate, handleClose, selectedDate}) => {
  let value = getLuxonDate(selectedDate);
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DateCalendar value={value} onChange={(date) => {
        handleClose();
        navigate(null, date)
        }} />
    </LocalizationProvider>
  );
}

const CalendarSelectPopover = ({ handleClose, anchorEl, navigate, date }) => {

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <CalendarSelect navigate={navigate} handleClose={handleClose} selectedDate={date} />
    </Popover>
  );
}

const SelectDate = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();

  const queryParams = useQueryParams();

  let selectedDate = queryParams?.date || new Date().toLocaleDateString();

  const { isMobile } = useIsMobile();
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateUrl = (e, date) => {
    let today = getToday();
    let dateStr = `${today.month + 1}/${today.day}/${today.year}`
    if (date) {
      let {day, month, year} = getDateParts(date)
      dateStr = `${month}/${day}/${year}`
    }
    let curView = "timeline"
    // let curView = queryParams?.view || "timeline"
    navigate(`?view=${curView}&date=${dateStr}`);
  }

  return (
    <>
    <ButtonGroup>
      <Tooltip title="Go To Today"><ActionButton variant="outlined" color="secondary" onClick={navigateUrl}>
        {isMobile ? <GpsFixedRoundedIcon fontSize={isMobile ? "small" : "medium"} /> : <BasicFlex gap=".8rem"><GpsFixedRoundedIcon fontSize={isMobile ? "small" : "medium"} /> Today </BasicFlex>}
        </ActionButton></Tooltip>
      <Tooltip title="Select Date"><ActionButton variant="outlined" color="secondary" onClick={handleClick}><EditCalendarRoundedIcon fontSize={isMobile ? "small" : "medium"} /></ActionButton></Tooltip>
    </ButtonGroup>
  <CalendarSelectPopover anchorEl={anchorEl} handleClose={handleClose} navigate={navigateUrl} date={selectedDate} />
    </>
  )
};

export default SelectDate;